import { toast } from "sonner";

const baseToastStyles = {
  border: "none",
  color: "white",
} as const;

export const showSuccessToast = (
  message: string,
  options?: { description?: string }
) => {
  // Si description existe, on la met à la ligne dans le message principal
  const fullMessage = options?.description
    ? `${message}\n${options.description}`
    : message;

  toast.success(fullMessage, {
    style: {
      ...baseToastStyles,
      background: "#10b981",
    },
  });
};

export const showErrorToast = (
  message: string,
  options?: { description?: string }
) => {
  // Si description existe, on la met à la ligne dans le message principal
  const fullMessage = options?.description
    ? `${message}\n${options.description}`
    : message;

  toast.error(fullMessage, {
    style: {
      ...baseToastStyles,
      background: "#ef4444",
    },
  });
};

// Toast de confirmation avec un bouton d'action (ex. "Supprimer ce créneau ?")
export const showConfirmToast = ({
  title,
  description,
  actionLabel = "Confirmer",
  onConfirm,
}: {
  title: string;
  description?: string;
  actionLabel?: string;
  onConfirm: () => void;
}) => {
  toast(title, {
    description,
    action: {
      label: actionLabel,
      onClick: onConfirm,
    },
  });
};
